interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-394">
      <div className="ml" data-id="element-395">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-396">{value}</div>
      <div className="ms" data-id="element-397">{sub}</div>
    </div>;
}